import { useFormik } from 'formik';
import React, { useState } from 'react'
import { Modal, Button, Form } from "react-bootstrap";
import { generateValidationSchema } from '../Validations';
import { useTermsAgreeMutation } from '../../State/Api/AddClinicInfoApiSlice';
import { BlobProvider } from "@react-pdf/renderer";
import FreeTrialAgreementPDF from '../FreeTrialAgreementPDF';
import { Download } from "lucide-react";
import { useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-input-2';

const TermsandConditions = ({showTermsModal,setShowTermsModal,termsAccepted,isFirstLogin}) => {
    const formFields = ["email", "fullname","primaryphonenumber","name"];
  const validationSchema = generateValidationSchema(formFields);
  const clinicUserId = localStorage.getItem("userClinicID");
  console.log(clinicUserId);
  const [termsAgree]=useTermsAgreeMutation();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: { 
        email: "",
        fullname: "",
        primaryphonenumber:"",
        name:"",
        clinicID:clinicUserId,
        TermsAndConditions:isFirstLogin
 },
 validationSchema: validationSchema,
  onSubmit: (values, { resetForm }) => handleSubmit(),
  });
      const handleSubmit = async () => {
    try {
      formik.setSubmitting(true);

      // Create FormData for multipart/form-data
      const formData = new FormData();
      formData.append('FullName', formik.values.fullname);
      formData.append('EmailID', formik.values.email);
      formData.append('PhoneNumber', formik.values.primaryphonenumber);
      formData.append('clinicID', clinicUserId);
      formData.append('TermsAndConditions', true); 
      formData.append('Name', formik.values.name);

      // Call RTK Query mutation
      const result = await termsAgree(formData).unwrap();
      
      setShowTermsModal(false);
      formik.resetForm();
      navigate("/ClinicDashboard");
    } catch (error) {
      console.error('Error submitting terms:', error);
      
    } finally {
      formik.setSubmitting(false);
    }
  };
   const [agreed, setAgreed] = useState(false);
   const [phone, setPhone] = useState("");
   const handlePhoneChange = (e) => {
  const value = e.target.value;
  // Only allow digits and maximum 10 characters
  if (/^\d{0,10}$/.test(value)) {
    formik.setFieldValue('primaryphonenumber', value);
  }
};
  return (
    <>
    <style>
        {`
          .bullet-list {
            list-style-type: disc;
            padding-left: 1.5rem;
          }

          .bullet-list li {
            margin-bottom: 0.5rem;
          }
            .dark-checkbox input[type="checkbox"] {
  accent-color: #000; /* Dark gray or use #000 for black */
}
  .dark-border-checkbox .form-check-input {
  border: 1px solid #333; /* Dark border when not checked */
}

        `}
      </style>
    <Modal show={showTermsModal} centered size="lg"
        backdrop="static"
        keyboard={false} >
        <Modal.Header>
          <Modal.Title>Free Trial Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                  <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
                   <form onSubmit={formik.handleSubmit}>


                   <div className='row'>
                    <div className="col-md-4 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Full Name<span className="text-danger">*</span>
            </label>
            <input
                      type="text"
                      className='form-control'
                      placeholder="Enter Full Name"
                      name="fullname"
                      value={formik.values.fullname}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      
                    />
                    {formik.touched.fullname && formik.errors.fullname && (
                      <div style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}>{formik.errors.fullname}</div>
                    )}
          </div>
        </div>
        <div className="col-md-4 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Email<span className="text-danger">*</span>
            </label>
            <input
                      type="email"
                      className='form-control'
                      placeholder="Enter Email Address"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}>{formik.errors.email}</div>
                    )}
          </div>
        </div>
        <div className="col-md-4 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Phone Number<span className="text-danger">*</span>
            </label>
            <PhoneInput
  country="in"
  onlyCountries={["in"]}
  disableDropdown={true}
  countryCodeEditable={false}
  value={formik.values.primaryphonenumber}
  onChange={(value, country) => {
    formik.setFieldValue("primaryphonenumber", value);
    formik.setFieldValue("primaryphonenumberCode", `+${country.dialCode}`);
  }}
  inputClass="form-control"
  specialLabel=""
  inputProps={{
    name: "primaryphonenumber",
    onBlur: formik.handleBlur,
  }}
/>
{formik.touched.primaryphonenumber && formik.errors.primaryphonenumber && (
  <div style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}>{formik.errors.primaryphonenumber}</div>
)}
          </div>
        </div>
        </div>
        <h4 className="text-center mb-4">Free Trial Agreement</h4>
            
            <p><strong>Effective Date:</strong> Upon User's acceptance</p>
            
            <p>
              This Free Trial Agreement ("Agreement") is made between <strong>Ready Shine Solutions Pvt Ltd.</strong> ("Company") 
              and the individual or entity ("User") who registers to access the PelicanRx – OPD Module ("Software").
            </p>
            
            <p>
              By clicking <strong>"I Accept"</strong> or signing up to use the Software, the User acknowledges and agrees to the following terms:
            </p>

            <h5 className="h5">1. Free Trial Access</h5>
            <ul className="bullet-list">
              <li>The Company grants the User a <strong>non-exclusive, non-transferable, limited license</strong> to access and use the OPD Module for <strong>15 days</strong> ("Trial Period") at no cost.</li>
              <li>The Trial Period begins upon User signup using a valid email ID.</li>
            </ul>

            <h5 className="h5">2. Scope of Access</h5>
            <p>During the Trial Period, the User will have access to:</p>
            <ul className="bullet-list">
              <li>Doctor Login with dashboard features.</li>
              <li>Clinic Admin Login with dashboard features.</li>
              <li>Billing dashboard with analytics and overview.</li>
            </ul>
            <p>Future modules (e.g., Pharmacy Management, Ward Management, OT Management) are <strong>not included</strong> in the Free Trial unless otherwise stated by the Company.</p>

            <h5 className="h5">3. User Obligations</h5>
            <p>The User shall:</p>
            <ul className="bullet-list">
              <li>Provide accurate signup information (including valid email ID).</li>
              <li>Use the Software in compliance with applicable laws and for legitimate healthcare practice/administration purposes only.</li>
              <li>Not attempt to copy, modify, reverse-engineer, or misuse the Software.</li>
            </ul>

            <h5 className="h5">4. Termination of Trial</h5>
            <ul className="bullet-list">
              <li>The Trial Period automatically expires at the end of 15 days.</li>
              <li>Continued access requires the User to choose one of the <strong>payment options</strong>:
                <ol style={{paddingLeft: '2rem', marginTop: '0.5rem'}}>
                  <li><strong>Subscription Model</strong></li>
                  <li><strong>Enterprise Model</strong></li>
                </ol>
              </li>
              <li>The User may continue with the same registered email ID to activate paid access seamlessly.</li>
            </ul>

            <h5 className="h5">5. Data & Privacy</h5>
            <ul className="bullet-list">
              <li>The Company may collect and process certain information during the Trial for the purpose of providing services and improving the Software.</li>
              <li>The Company will not disclose User data to third parties except as required by law.</li>
              <li>User is responsible for the accuracy and legality of patient and clinical data entered.</li>
            </ul>

            <h5 className="h5">6. Disclaimer of Warranties</h5>
            <ul className="bullet-list">
              <li>The Software is provided <strong>"AS IS"</strong> during the Free Trial.</li>
              <li>The Company makes no warranties, express or implied, including merchantability, fitness for a particular purpose, or uninterrupted operation.</li>
            </ul>

            <h5 className="h5">7. Limitation of Liability</h5>
            <ul className="bullet-list">
              <li>The Company shall not be liable for any indirect, incidental, or consequential damages arising out of the use or inability to use the Software during the Trial Period.</li>
            </ul>

            <h5 className="h5">8. Acceptance</h5>
            <p>By clicking <strong>"I Accept"</strong>, the User confirms that they have read, understood, and agreed to be bound by the terms of this Agreement.</p>

            {/* SIMPLE VERSION */}
            <div className="version-divider">
              <h4 className="text-center mb-4">Simple Version: Free Trial Terms & Conditions</h4>
              
              <p>Welcome to <strong>Ready Shine Solutions Pvt Ltd.'s Pelican Rx – OPD Module</strong>.<br/>
              Before starting your <strong>15-day free trial</strong>, please read and accept the terms below.</p>

              <h5 className="h5">1. Free Trial Access</h5>
              <ul className="bullet-list">
                <li>You get <strong>15 days of free access</strong> to the OPD Module using your email ID.</li>
                <li>The trial includes <strong>Doctor Login, Clinic Admin Login, and Billing Dashboard with analytics</strong>.</li>
              </ul>

              <h5 className="h5">2. After the Trial</h5>
              <p>At the end of 15 days, you can continue using the same email ID to unlock full access by choosing one of the plans:</p>
              <ol style={{paddingLeft: '2rem'}}>
                <li><strong>Subscription Model</strong></li>
                <li><strong>Enterprise Model</strong></li>
              </ol>

              <h5 className="h5">3. What You Agree To</h5>
              <p>By using the trial, you agree to:</p>
              <ul className="bullet-list">
                <li>Use the software only for genuine healthcare/clinic purposes.</li>
                <li>Provide correct signup details.</li>
                <li>Not copy, misuse, or tamper with the software.</li>
              </ul>

              <h5 className="h5">4. Data & Privacy</h5>
              <ul className="bullet-list">
                <li>We may collect basic information during your trial to improve our services.</li>
                <li>Patient/clinic data entered is your responsibility.</li>
                <li>We do not share your data with third parties unless required by law.</li>
              </ul>

              <h5 className="h5">5. Important Notes</h5>
              <ul className="bullet-list">
                <li>The trial software is provided <strong>"as is"</strong> – we do not guarantee uninterrupted service during the free trial.</li>
                <li>We are not responsible for any loss or damages caused by use of the trial version.</li>
              </ul>

              <h5 className="h5">6. Agreement</h5>
              <p>By clicking <strong>"I Accept"</strong>, you confirm that you have read and agreed to these terms.</p>
            </div>
                    
                    <h5 className="h5">Free Trial Agreement for Pelican Rx</h5>

<h5 className="h5">Effective Date</h5>
<p>
  This Free Trial Agreement ("Agreement") becomes legally binding and effective upon the date 
  the User completes the registration process and clicks the "I Accept" button or otherwise 
  accesses or uses the Software.
</p>

<h5 className="h5">Parties</h5>
<p>This Agreement is entered into between:</p>
<ul className="bullet-list">
  <li>
    <strong>Ready Shine Solutions Pvt Ltd.,</strong> a company incorporated under the laws of 
    India, with its principal place of business at <strong>H.no.47-11-16, Flat No:805 Grand Palace, 
    7th floor, Dwaraka Nagar, Visakhapatnam, Andhra Pradesh 530016</strong> (hereinafter referred 
    to as the "Company", "We", "Us", or "Our").
  </li>
  <li>
    The individual, clinic, hospital, or legal entity registering for the free trial (hereinafter 
    referred to as the "User", "You", or "Your").
  </li>
</ul>
<p>
  By creating an account or using the Software on a trial basis, the User signifies their 
  unconditional agreement to be bound by the terms and conditions set forth herein. If the User 
  is accepting on behalf of an organization, they represent and warrant that they have the full 
  legal authority to bind said organization to this Agreement.
</p>

<h5 className="h5">1. Grant of Limited License for Free Trial</h5>
<p><strong>1.1. License Grant:</strong> Subject to the terms and conditions of this Agreement, 
the Company hereby grants the User a personal, non-exclusive, non-transferable, non-sub licensable, 
revocable, and limited license to access and use the PelicanRx -- OPD Module (the "Software") 
during the Trial Period.</p>

<p><strong>1.2. Purpose:</strong> This license is granted for the sole purpose of evaluating 
the Software's features and functionality for the User's internal business or professional purposes. 
Use of the Software for any other purpose, including but not limited to commercial production, 
resale, or service bureau use, is strictly prohibited.</p>

<p><strong>1.3. Trial Period:</strong> The free trial shall be for a period of <strong>15 (fifteen) 
consecutive calendar days</strong> ("Trial Period"). The Trial Period shall commence on the date 
and time the User successfully completes the registration process with a valid and verifiable email ID.</p>

<h5 className="h5">2. Scope of Access and Services</h5>
<p><strong>2.1. Included Features:</strong> During the Trial Period, the User will be granted 
access to a limited feature set of the Software, which includes, but is not limited to:</p>
<ul className="bullet-list">
  <li><strong>Doctor Login:</strong> Access to a personalized dashboard for managing appointments, 
  patient records, and clinical workflows.</li>
  <li><strong>Clinic Admin Login:</strong> Access to an administrative dashboard for managing 
  staff schedules, patient registrations, and operational settings.</li>
  <li><strong>Billing Dashboard:</strong> Access to an analytics and overview dashboard for 
  viewing billing summaries and financial metrics generated from trial data.</li>
</ul>

<p><strong>2.2. Exclusions:</strong> This Agreement does not grant any rights to modules, features, 
or services not explicitly listed above. Specifically, access to the following is excluded from 
the Free Trial unless otherwise expressly offered in writing by the Company:</p>
<ul className="bullet-list">
  <li>Pharmacy Management Module</li>
  <li>Ward Management / In-Patient Department (IPD) Module</li>
  <li>Operation Theatre (OT) Management Module</li>
  <li>Any future modules or premium add-ons.</li>
</ul>

<p><strong>2.3. Service Limitations:</strong> The Company reserves the right to impose limitations 
on the use of the trial version, including but not limited to, limitations on data storage capacity, 
number of user accounts, and access to premium support channels.</p>

<h5 className="h5">3. User Obligations and Responsibilities</h5>
<p><strong>3.1. Accurate Information:</strong> The User agrees to provide true, accurate, current, 
and complete information during the registration process, including a valid email address for 
communication and account verification.</p>

<p><strong>3.2. Lawful Use:</strong> The User shall use the Software strictly in compliance with 
all applicable local, state, national, and international laws, regulations, and professional codes 
of conduct, including those related to healthcare, data privacy, and patient confidentiality.</p>

<p><strong>3.3. Prohibited Activities:</strong> The User shall not, and shall not permit any 
third party to:</p>
<ul className="bullet-list">
  <li>Reverse-engineer, decompile, disassemble, or otherwise attempt to discover the source code, 
  object code, or underlying structure of the Software.</li>
  <li>Copy, modify, translate, or create derivative works based on the Software.</li>
  <li>Sell, rent, lease, sublicense, distribute, or otherwise transfer rights to the Software.</li>
  <li>Use the Software to store or transmit infringing, libelous, or otherwise unlawful material, 
  or to store or transmit material in violation of third-party privacy rights.</li>
  <li>Introduce any viruses, worms, Trojan horses, or other malicious code into the Software.</li>
  <li>Attempt to gain unauthorized access to the Software, its related systems, or networks.</li>
  <li>Use the Software to build a competitive product or service.</li>
</ul>

<p><strong>3.4. Account Security:</strong> The User is solely responsible for maintaining the 
confidentiality of their login credentials and for all activities that occur under their account.</p>

<h5 className="h5">4. Trial Period Expiration, Termination, and Conversion</h5>
<p><strong>4.1. Automatic Expiration:</strong> The User's access to the Software under this 
Agreement will automatically terminate without notice at the end of the 15-day Trial Period.</p>

<p><strong>4.2. Conversion to Paid Service:</strong> To continue using the Software after the 
Trial Period, the User must proactively select a paid plan offered by the Company:</p>
<ul className="bullet-list">
  <li>Subscription Model</li>
  <li>Enterprise Model</li>
</ul>
<p>and provide valid payment information. Upon conversion, the User's use of the Software will 
be governed by the Company's standard Terms of Service and Privacy Policy, which will supersede 
this Agreement.</p>

<p><strong>4.3. Data Retention and Deletion:</strong> Upon expiration of the Trial Period, the 
Company has no obligation to retain any data, including patient and clinical data, entered by 
the User. The Company reserves the right to permanently delete all such data from its systems 
thirty (30) days after the trial ends if the User has not converted to a paid service.</p>

<h5 className="h5">5. Data, Privacy, and Confidentiality</h5>
<p><strong>5.1. Data Collection:</strong> The User acknowledges that the Company may collect 
usage data, technical information, and feedback during the Trial Period for the purposes of 
service provision, troubleshooting, and software improvement.</p>

<p><strong>5.2. User-Generated Data:</strong> The User is solely responsible for the accuracy, 
legality, quality, and integrity of all patient, clinical, and administrative data entered into 
the Software. The User warrants that they have obtained all necessary consents and permissions 
required by law to input and process such data.</p>

<p><strong>5.3. Confidentiality:</strong> The Company will treat User data as confidential and 
will not disclose it to third parties, except as required to provide the service or as compelled 
by law.</p>

<h5 className="h5">6. Disclaimer of Warranties</h5>
<p>
  THE SOFTWARE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY WARRANTIES OF ANY KIND. TO THE 
  FULLEST EXTENT PERMITTED BY LAW, THE COMPANY EXPRESSLY DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, 
  IMPLIED, OR STATUTORY, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, 
  FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. THE COMPANY DOES NOT WARRANT 
  THAT THE SOFTWARE WILL BE UNINTERRUPTED, ERROR-FREE, SECURE, OR FREE FROM VIRUSES OR OTHER 
  HARMFUL COMPONENTS.
</p>

<h5 className="h5">7. Limitation of Liability</h5>
<p>
  IN NO EVENT SHALL THE COMPANY, ITS DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, 
  INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, LOST 
  PROFITS, LOST DATA, BUSINESS INTERRUPTION, OR COST OF PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES, 
  ARISING OUT OF OR IN CONNECTION WITH THE USE OR INABILITY TO USE THE SOFTWARE DURING THE TRIAL 
  PERIOD, EVEN IF THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE COMPANY'S 
  TOTAL AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS FREE TRIAL AGREEMENT SHALL NOT 
  EXCEED ZERO DOLLARS ($0.00).
</p>

<h5 className="h5">8. Governing Law and Jurisdiction</h5>
<p>
  This Agreement and any disputes arising from it shall be governed by and construed in accordance 
  with the laws of <strong>Andhra Pradesh Vaidya Vidhana Parishad Act 1986 by the State of Andhra 
  Pradesh, India</strong>, without regard to its conflict of law principles. The parties agree 
  that the exclusive jurisdiction and venue for any legal proceedings shall be the competent 
  courts located in <strong>Visakhapatnam, Andhra Pradesh</strong>.
</p>

<h5 className="h5">9. General Provisions</h5>
<p><strong>9.1. Entire Agreement:</strong> This Agreement constitutes the entire agreement between 
the parties concerning the subject matter hereof and supersedes all prior or contemporaneous 
agreements, understandings, or communications, whether oral or written.</p>

<p><strong>9.2. Modification:</strong> The Company reserves the right to modify the terms of this 
Agreement at any time. Continued use of the Software after any such changes shall constitute the 
User's consent to such changes.</p>

<p><strong>9.3. Severability:</strong> If any provision of this Agreement is held to be unenforceable 
or invalid, that provision will be limited or eliminated to the minimum extent necessary so that 
this Agreement will otherwise remain in full force and effect.</p>

<h5 className="h5">10. Acceptance of Terms</h5>
<p>
  BY CLICKING THE "I ACCEPT" BUTTON, CREATING AN ACCOUNT, OR OTHERWISE ACCESSING OR USING THE 
  SOFTWARE, THE USER CONFIRMS THAT THEY HAVE READ, UNDERSTOOD, AND AGREE TO BE LEGALLY BOUND BY 
  ALL THE TERMS AND CONDITIONS OF THIS AGREEMENT. IF THE USER DOES NOT AGREE TO THESE TERMS, 
  THEY MUST NOT ACCESS OR USE THE SOFTWARE.
</p>

                     <div className='row'>
                    <div className="col-md-4 col-12">
          <div className="input-block mb-1">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Enter Full Name Before Agree<span className="text-danger">*</span>
            </label>
            <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Full Name"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <div style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}>{formik.errors.name}</div>
                    )}
          </div>
        </div>
        
        </div>
        
                   
                      <Form.Check
                  type="checkbox"
                  label="I Accept the Free Trial Terms & Conditions"
                  name="TermsAndConditions"
                  checked={formik.values.TermsAndConditions}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className='dark-border-checkbox ms-1'
                  style={{borderColor:'red'}}
                  // disabled={termsAccepted && !isFirstLogin || isLoading}
                />
                {formik.touched.TermsAndConditions && formik.errors.TermsAndConditions && (
                  <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                    {formik.errors.TermsAndConditions}
                  </div>
                )}
                      <Button
                        variant="primary"
                        type="submit"
                        className="gradient-dark-button mt-3"
                        disabled={!formik.values.TermsAndConditions}

                      >
                        Accept & Submit
                      </Button>

                                  {/* <BlobProvider
              document={<FreeTrialAgreementPDF invoiceData={""} />}
            >
              {({ url, loading, error }) => (
                <button
                  onClick={() => {
                    if (url && !loading) {
                      const link = document.createElement("a");
                      link.href = url;
                      link.download = `FreeTrialAgreement.pdf`;
                      link.click();
                    }
                  }}
                  disabled={loading}
                  className="gradient-button px-4 py-2 rounded-lg font-medium flex items-center gap-2"
                  style={{ opacity: loading ? 0.7 : 1 }}
                >
                  <Download className="w-4 h-4" />
                  {loading ? "Generating..." : "Download PDF"}
                </button>
              )}
            </BlobProvider> */}
                    </form>
                  </div>
                </Modal.Body>
      </Modal>
      </>
  )
}

export default TermsandConditions